export const data = [
  {
    title: 'Gaurav Ahuja, ChrysCapital',
    url: 'https://youtu.be/5wr71cbRLFk?feature=shared',
    id: '0aV5ivLwgqI',
    length: '1:08',
    milis_length: 68000,
    thumbnail_url: 'https://img.youtube.com/vi/5wr71cbRLFk/sddefault.jpg',
  },
  {
    title:
      'Sanjeev Bhikchandani, Co-founder and Executive Vice Chairman, Info Edge ',
    url: 'https://youtu.be/QGhPjGWSlPA?feature=shared',
    id: '0aV5ivLwgqI',
    length: '1:08',
    milis_length: 68000,
    thumbnail_url: 'https://img.youtube.com/vi/QGhPjGWSlPA/sddefault.jpg',
  },
  {
    title: 'Lavanya Ashok,Trifecta Capital ',
    url: ' https://youtu.be/EcfqNpeNVHs?feature=shared',
    id: '0aV5ivLwgqI',
    length: '1:08',
    milis_length: 68000,
    thumbnail_url: 'https://img.youtube.com/vi/EcfqNpeNVHs/sddefault.jpg',
  },
];
export const dataRanjan = [
  {
    title:
      'Rajan Anandan, Managing Director, Peak XV Partners Co-Chair, IVCA VC Council',
    url: 'https://youtu.be/5kdM4U7STgw?feature=shared',
    id: '0aV5ivLwgqI',
    length: '1:08',
    milis_length: 68000,
    thumbnail_url: 'https://img.youtube.com/vi/5kdM4U7STgw/sddefault.jpg',
  },
];

export const hearData = [
  {
    title: 'Manish Khetrapal',
    url: 'https://www.youtube.com/watch?v=3AWEK2pNn7s',
    id: '1',
    length: '',
    milis_length: 6800,
    thumbnail_url: 'https://img.youtube.com/vi/3AWEK2pNn7s/sddefault.jpg',
  },
];

export const hearRanjan = [
  {
    title:
      'Rajan Anandan, Managing Director, Peak XV Partners Co-Chair, IVCA VC Council',
    url: 'https://www.youtube.com/playlist?list=PLHR3PNcbEp9jhQqn7HzLLt6dsFYogKLPu',
    id: '0aV5ivLwgqI',
    length: '1:08',
    milis_length: 68000,
    thumbnail_url: 'https://img.youtube.com/vi/wyIcPGpVJG8/sddefault.jpg',
  },
];
export const hearManish = [
  {
    title:
      'Manish Khetrapal, Co-Founder & Partner, WaterBridge Ventures Vice-Chair, IVCA VC Council',
    url: 'https://www.youtube.com/watch?v=3AWEK2pNn7s',
    id: '1',
    length: '',
    milis_length: 6800,
    thumbnail_url: 'https://img.youtube.com/vi/3AWEK2pNn7s/sddefault.jpg',
  },
];
export const hearGreenReturnLeader = [
  {
    title: '',
    url: 'https://youtu.be/1JIYNegNsnM',
    id: '1',
    length: '',
    milis_length: 6800,
    thumbnail_url: 'https://i3.ytimg.com/vi/1JIYNegNsnM/maxresdefault.jpg',
  },
];
